import { type ColDef } from 'ag-grid-community';
import { t } from 'i18next';
import { PencilSquare } from 'react-bootstrap-icons';

import { ActionsGrid } from '@/app/components/grid';
import { type ActionColumn } from '@/app/components/grid/actions-column';

import { type CatalogValue } from '../../models/Catalog';

export const getColumns = (onEdit: (catalog: CatalogValue) => void): Array<ColDef> => {
  const actions: Array<ActionColumn> = [
    {
      icon: PencilSquare,
      variant: 'secondary',
      onClick: async (row: CatalogValue) => {
        onEdit(row);
      }
    }
  ];

  const colDef: Array<ColDef> = [
    {
      headerName: t('common.label.actions'),
      cellRenderer: ActionsGrid,
      cellRendererParams: {
        actions: actions
      }
    },
    {
      headerName: t('catalog.values.code'),
      field: 'code'
    },
    { headerName: t('catalog.values.name'), field: 'name' }
  ];

  return colDef;
};
